import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import HiristJobs from '@/features/hirist/jobs'

const searchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  filter: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/hirist/jobs/')({
  component: HiristJobs,
  validateSearch: (search) => searchSchema.parse(search),
})
